var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useCallback, useMemo, useState } from "react";
import OutlinedInput from "@mui/material/OutlinedInput";
import config from "../../../assests/config";
import { Button } from "../../Button";
import { Dialog } from "../../Dialog";
import ForcedPasswordDialog from "./ForcedPasswordChanged";
import { ErrorMessage } from "../../ErrorMessage";
import { useForm } from "../../../hooks/UseForm";
import { useCommonLoader } from "../../Loader";
import { getInputFields, initialState, dialogDetails } from "./data";
import { modifyDialogContent } from "./hanlders";
import { AuthenticationScreens } from "../data";
import Styled from "./style";
// import {
//   getUserDetailsForgotAgency
// } from "./hanlders";
export const forgotPasswordHandles = [
    AuthenticationScreens.FP,
    AuthenticationScreens.CR,
];
const ForgotPasswordComponent = (props) => {
    const { changeConfig, authenticationFlow } = props;
    const [error, setError] = useState("");
    // Forgotpassword response
    const [showDialog, setShowDialog] = useState(null);
    const [emailStatus, setEmailStatus] = useState("");
    const { onChange, onSubmit, values } = useForm(submitCallback, initialState);
    const { setLoading, unSetLoading } = useCommonLoader();
    // a submit function that will execute upon form submission
    function submitCallback() {
        return __awaiter(this, void 0, void 0, function* () {
            showDialog && setShowDialog(null);
            error && setError("");
            /**
             * It will validate about the length of the value as per requirement
             */
            const hasMinLengthValues = Object.values(values);
            if (hasMinLengthValues.find((data) => data.length < 3))
                return setError("Please provide valid details");
            try {
                setLoading();
                // if (props.UI === "agency") {
                //   const response = await getUserDetailsForgotAgency({ validEmailId: values.email });
                //   unSetLoading();
                //   changeConfig(response?.nextAuth);
                // } else {
                const response = (yield authenticationFlow(Object.assign({}, values)));
                unSetLoading();
                if (response.dialog) {
                    // Open Resend Dialog
                    let dialogContent = dialogDetails[response.dialog];
                    dialogContent = modifyDialogContent({
                        dialog: response.dialog,
                        dialogContent: Object.assign({}, (dialogContent || {})),
                        props,
                        values,
                    });
                    return setShowDialog(dialogContent);
                }
                changeConfig(response === null || response === void 0 ? void 0 : response.nextAuth);
                // }
            }
            catch (error) {
                unSetLoading();
                if (error === null || error === void 0 ? void 0 : error.dialog) {
                    let dialogContent = dialogDetails[(error === null || error === void 0 ? void 0 : error.dialog) || "noActiveAccount"];
                    dialogContent = modifyDialogContent({
                        dialog: error === null || error === void 0 ? void 0 : error.dialog,
                        dialogContent: Object.assign({}, dialogContent),
                        props,
                        values,
                    });
                    // if (error?.dialog !== "noActiveAccount")
                    // setError(
                    //   error.message === config.errorMessages.NETWORK_ERROR
                    //     ? dialogContent.content || config.errorMessages.SOMETHING_WRONG
                    //     : error.message
                    // );
                    console.error(`config: ${props.config}:`, error);
                    setShowDialog(Object.assign({}, dialogContent));
                }
            }
        });
    }
    const inputFields = useMemo(() => getInputFields(props.config), [props.config]);
    const resendEmailHandler = useCallback((btnInfo) => __awaiter(void 0, void 0, void 0, function* () {
        setShowDialog(null);
        if (btnInfo.label === "Close" || !btnInfo.label) {
            return emailStatus && setEmailStatus("");
        }
        else if (btnInfo.label === config.sections.FORGOT_YOUR_PASSWORD) {
            return changeConfig(AuthenticationScreens.FP);
        }
        else if (btnInfo.label === config.headings.GO_TO_SIGNIN) {
            return changeConfig(AuthenticationScreens.login);
        }
        // Resend Email
        try {
            setShowDialog(null);
            yield authenticationFlow({ resendEmail: true });
            setEmailStatus(config.headings.EMAIL_SENT);
            setShowDialog(dialogDetails["emailSentSuccesfully"]);
        }
        catch (error) {
            setShowDialog(null);
            setEmailStatus(config.errorMessages.SOMETHING_WRONG);
            setShowDialog(dialogDetails["noActiveAccount"]);
        }
    }), [emailStatus, showDialog, changeConfig, authenticationFlow, showDialog]);
    const navigateToSignIn = () => changeConfig(AuthenticationScreens.login);
    return (React.createElement(Styled, { className: `forgot-password config-${props.UI}` },
        error ? React.createElement(ErrorMessage, { error: error }) : null,
        React.createElement("section", null,
            React.createElement("div", { className: "forgot-text" },
                React.createElement("div", null, inputFields.info.title),
                React.createElement("p", { dangerouslySetInnerHTML: { __html: inputFields.info.description } })),
            React.createElement("form", { onSubmit: onSubmit },
                React.createElement(OutlinedInput, Object.assign({}, inputFields.email, { onChange: onChange })),
                React.createElement(Button, Object.assign({}, inputFields.resetPassword)))),
        React.createElement("div", { className: "forgot-password_go-to-sign" },
            React.createElement("span", null, "Go back to"),
            " ",
            React.createElement(Button, Object.assign({}, inputFields.signIn, { onClick: navigateToSignIn }))),
        showDialog && (React.createElement(Dialog, { show: true, title: showDialog.title, body: () => (React.createElement(ForcedPasswordDialog, { content: showDialog.content, emailStatus: emailStatus || showDialog.emailStatus })), buttons: showDialog.buttons, handleCallback: resendEmailHandler }))));
};
export const ForgotPassword = React.memo(ForgotPasswordComponent);
